import React from "react";
import t from '../../../helpers/t';

const ExtraIcon = (props) => {
    let className = "fi fi-volume";
   // let title = t('signalSound');
    if (props.Name === 'theft') {
        className = "fi fi-target-two";
        className += " " + (props.Resource.theft ? "styleGreen" : "");
      //  title = t('theft');
    }
    let classNameB = props.Name === 'signalSound' ? "inb-fi-volume tiny" : props.Name === 'theft' ? "inb-fi-target-two tiny" : "";

    return (
        <>
            <div className={classNameB} style={{float: 'left', marginRight: '8px'}} key={"icon_div_resource_button_extra_"+props.Resource.id}> </div>
            <div style={{float: 'left', display: "flex"}} key={"icon2_div_resource_button_extra_"+props.Resource.id}>
                <a href="#" onClick={() => props.EventHandler(props.Resource)} style={{color:"#5d687e"}} key={"icon_a_resource_button_extra_"+props.Resource.id}><i className={className}
                   style={{float: 'left', width: '20px', height: '18px', lineHeight: '18px'}} key={"icon_i_resource_button_extra_"+props.Resource.id}> </i></a>
            </div>
        </>
    );

}

export default ExtraIcon;

